import { render, staticRenderFns } from "./GeneralPolarAreaChart.vue?vue&type=template&id=5be63b4a"
import script from "./GeneralPolarAreaChart.vue?vue&type=script&lang=js"
export * from "./GeneralPolarAreaChart.vue?vue&type=script&lang=js"
import style0 from "./GeneralPolarAreaChart.vue?vue&type=style&index=0&id=5be63b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports